import api from "./api";

export const getRealtimeHistory = (serial) => {

    return api.get(`/stats/realtime/${serial}`);

};